import { ApiError } from '../../../api/client';
import type { ClientSettingDefinition } from './setting-catalog';

/** Codes from `apps/api` `SettingsExceptionFilter`. */
export function mapSystemParametersError(
  error: unknown,
  definition?: ClientSettingDefinition,
): string {
  if (!(error instanceof ApiError)) {
    return 'Ocurrió un error de conexión. Intentá de nuevo.';
  }

  const code = (error.body as { code?: string } | null)?.code;

  if (error.status === 403 && code === 'SETTING_SYSTEM_PROTECTED') {
    return 'Este parámetro es de sistema y no se puede modificar.';
  }

  if (error.status === 403) {
    return 'No tenés permiso para modificar este parámetro.';
  }

  if (error.status === 400 && code === 'INVALID_SETTING_VALUE') {
    return definition?.invalidMessage ?? 'El valor no es válido.';
  }

  if (error.status === 404) {
    return 'El parámetro solicitado no existe.';
  }

  return 'Ocurrió un error inesperado. Intentá de nuevo.';
}
